module.exports = __webpack_public_path__ + "img/logo_footer.a87291d1.png";